import React, { useState } from "react";
import { ExpandableContent } from "../../../components/CustomControls/ExpandableContent";
import { useProcedures, useProcedureHistoryByConcept } from "../Hooks/useProcedures";
import { Procedures } from "../../../components/MedicalRecords/Procedures";
import { AuditModal } from "../../../components/AuditTrail/AuditModal";
import { AuditTrail } from "../../Admin/AuditTrail";
import { useTranslation } from "react-i18next";
import { ModalConceptHistory } from "../Modals/ModalConceptHistory";

export const ProceduresListContainer = ({ mrn, medicalRecordNumber, entryId, expandedAll }) => {
    const { t } = useTranslation();
    const [drugs, query, totalSize, isLoading, handleTableChange, , setSearchTerm] = useProcedures(medicalRecordNumber, entryId);

    const [modal, setModal] = useState(null);
    const handleAuditTrail = (entityId) => {
        setModal(
            <AuditModal
                onClose={() => { setModal(null); }}
                title={t("auditTrail.audit")}
            >
                <AuditTrail entity="Procedures" entityId={entityId} medicalRecordNumber={medicalRecordNumber} />
            </AuditModal>
        )
    }
    const handleHistoryByConcept = (conceptId, _mrn) => {
        setModal(<ModalConceptHistory
            onClose={() => { setModal(null); }}
            title={t("medicalRecords.history.byConcept")}
            medicalRecordNumber={medicalRecordNumber || mrn}
            conceptId={conceptId}
            useHistoryHook={useProcedureHistoryByConcept}
            getConceptName={(row) => row.procedure}
            getCycleSubtitle={(row) => row.reason || ''}
        />)
    }

    if (entryId && totalSize === 0)
        return null;

    return (
        <ExpandableContent title={t("medicalRecords.procedures.title")} content="procedures" expandedAll={expandedAll}>
            {modal}
            <Procedures
                withCard={false}
                data={drugs}
                query={query}
                entryId={entryId}
                totalSize={totalSize}
                isLoading={isLoading}
                onTableChange={handleTableChange}
                onAuditTrail={handleAuditTrail}
                onHistoryByConcept={handleHistoryByConcept}
                onSearchTermChange={setSearchTerm}
            />
        </ExpandableContent>
    );
}